<template>
  <div class="saleAnalysis">
    <el-row justify="space-between" type="flex">
      <el-col :lg="14" :md="12" :sm="10" :xl="16" :xs="24" style="display:flex;align-items:center;">
        <label style="width:70px;">{{ $t('sale-order::shopName') }}</label>
        <el-select
          :placeholder="$t('system::common::select_placeholder')"
          @change="handlerSelectChange"
          :popperAppendToBody="false"
          v-model="selectedShop"
        >
          <el-option
            :key="item.shopId"
            :label="item.shopName"
            :value="item.shopId"
            v-for="item in shopList"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :lg="10" :md="12" :sm="14" :xl="8" :xs="24" style="display:flex;align-items:center;">
        <label style="width:150px;">{{ $t('sale-order::orderDate') }}</label>
        <el-date-picker
          :clearable="false"
          :appendToBody="false"
          :picker-options="pickerOptions"
          :range-separator="$t('system::time::text::include')"
          @change="orderDateChange"
          align="right"
          end-placeholder="结束日期"
          start-placeholder="开始日期"
          style="width:100%"
          type="daterange"
          unlink-panels
          v-model="orderDate"
        ></el-date-picker>
        <el-button style="margin-left: 8px;" @click="$router.push({ path: reportJumpUrl().refundAnalysis })">
          {{ $t('system::common::btn::check_report') }}
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="card-content">
      <el-col :key="index" :lg="6" :md="6" :sm="12" :xl="6" class="card-item" v-for="(item, index) in cardOptions">
        <dataCard :active="0" :option="item" v-loading="cardLoading">
          <template slot="total">
            <div class="card-content__total">{{ item.suffix }}</div>
          </template>
        </dataCard>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :lg="12" :md="12" :sm="24" :xl="12">
        <reportCard
          :config="refundReasonConfigs"
          :style="`height: ${reportHeight};`"
          v-loading="reportCardLoading"
        ></reportCard>
      </el-col>
      <el-col :lg="12" :md="12" :sm="24" :xl="12">
        <reportCard
          :config="refundTimeConfigs"
          :style="`height: ${reportHeight};`"
          v-loading="reportCardLoading"
        ></reportCard>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <reportTable :config="shopTableConfig" class="databoard-table" v-loading="tableLoading">
          <el-table-column :label="$t('sale-order::refund::table_img')" min-width="120">
            <template slot-scope="scope">
              <img :src="scope.row.productImage" style="width:72px;height:72px;" />
            </template>
          </el-table-column>
          <el-table-column label="spuId" min-width="100" prop="spuId">
            <template slot-scope="scope">{{ $dataCheck(scope.row.spuId) }}</template>
          </el-table-column>
          <el-table-column :label="$t('sale-order::refund::table_sales')" min-width="100" prop="saleAmount">
            <template slot-scope="scope">{{ $dataCheck(scope.row.saleAmount) }}</template>
          </el-table-column>
          <el-table-column :label="$t('sale-order::refund::table_refund')" min-width="100" prop="refundAmount">
            <template slot-scope="scope">{{ $dataCheck(scope.row.refundAmount) }}</template>
          </el-table-column>
          <el-table-column :label="$t('sale-order::refund::table_refundRate')" min-width="100" prop="refundRate">
            <template slot-scope="scope">{{ $dataCheck(scope.row.refundRate) + '%' }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('sale-order::refund::table_selfRefund')"
            min-width="125"
            prop="initiativeRefundAmount"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.initiativeRefundAmount) }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('sale-order::refund::table_selfRefundRate')"
            min-width="150"
            prop="initiativeRefundAmountPercentage"
          >
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.initiativeRefundAmountPercentage) + '%' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('sale-order::refund::table_protest')" min-width="100" prop="refuseAmount">
            <template slot-scope="scope">{{ $dataCheck(scope.row.refuseAmount) }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('sale-order::refund::table_protestRate')"
            min-width="125"
            prop="refuseAmountPercentage"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.refuseAmountPercentage) + '%' }}</template>
          </el-table-column>
        </reportTable>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <reportTable :config="countryTableConfig" class="databoard-table" v-loading="tableLoading">
          <el-table-column :label="$t('sale-order::refund::table_country')" prop="country">
            <template slot-scope="scope">{{ $dataCheck(scope.row.country) }}</template>
          </el-table-column>
          <el-table-column :label="$t('sale-order::refund::table_sales')" min-width="100" prop="saleAmount">
            <template slot-scope="scope">{{ $dataCheck(scope.row.saleAmount) }}</template>
          </el-table-column>
          <el-table-column :label="$t('sale-order::refund::table_recieve')" min-width="100" prop="recieveOkAmount">
            <template slot-scope="scope">{{ $dataCheck(scope.row.recieveOkAmount) }}</template>
          </el-table-column>
          <el-table-column :label="$t('sale-order::refund::table_refund')" min-width="100" prop="refundAmount">
            <template slot-scope="scope">{{ $dataCheck(scope.row.refundAmount) }}</template>
          </el-table-column>
          <el-table-column :label="$t('sale-order::refund::table_refundRate')" prop="refundRate">
            <template slot-scope="scope">{{ $dataCheck(scope.row.refundRate) + '%' }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('sale-order::refund::table_selfRefund')"
            min-width="125"
            prop="initiativeRefundAmount"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.initiativeRefundAmount) }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('sale-order::refund::table_selfRefundRate')"
            min-width="150"
            prop="initiativeRefundAmountPercentage"
          >
            <template slot-scope="scope">
              {{ $dataCheck(scope.row.initiativeRefundAmountPercentage) + '%' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('sale-order::refund::table_protest')" min-width="100" prop="refuseAmount">
            <template slot-scope="scope">{{ $dataCheck(scope.row.refuseAmount) }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('sale-order::refund::table_protestRate')"
            min-width="125"
            prop="refuseAmountPercentage"
          >
            <template slot-scope="scope">{{ $dataCheck(scope.row.refuseAmountPercentage) + '%' }}</template>
          </el-table-column>
        </reportTable>
      </el-col>
    </el-row>
    <el-row justify="space-between" style="margin-top:20px;" type="flex">
      <el-col :lg="14" :xl="16" style="display:flex;align-items:center;">
        <label style="width:70px;">{{ $t('sale-order::shopName') }}</label>
        <el-select
          :placeholder="$t('system::common::select_placeholder')"
          @change="refundSelectChange"
          v-model="selectedShop"
        >
          <el-option
            :key="item.shopId"
            :label="item.shopName"
            :value="item.shopId"
            v-for="item in shopList"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :lg="10" :xl="8" style="display:flex;align-items:center;">
        <label style="width:150px;">{{ $t('sale-order::refundDate') }}</label>
        <el-date-picker
          :clearable="false"
          :picker-options="pickerOptions"
          :range-separator="$t('system::time::text::include')"
          @change="refundDateChange"
          align="right"
          end-placeholder="结束日期"
          start-placeholder="开始日期"
          style="width:100%"
          type="daterange"
          unlink-panels
          v-model="refundDate"
        ></el-date-picker>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <reportCard
          :config="refundMoneyData"
          :style="`height: ${reportHeight};`"
          v-loading="reportCardLoading"
        ></reportCard>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :lg="24" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="initiativeRefundData"
          :style="`height: ${reportHeight};`"
          v-loading="reportCardLoading"
        ></reportCard>
      </el-col>
      <el-col :lg="24" :md="24" :sm="24" :xl="12">
        <reportCard
          :config="refuseCountData"
          :style="`height: ${reportHeight};`"
          v-loading="reportCardLoading"
        ></reportCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
import setConfig from './setConfig'
import { pickerOptions } from '@/utils/datepickerConfig'
import dataCard from '@/components/data-analysis/card'
import reportCard from '@/components/data-analysis/report'
import reportTable from '@/components/data-analysis/table'
import { getShopList } from '@/server/product'
import { reportJumpUrl } from '@/utils/config'
import {
  getRefundCount,
  getRefundReasonData,
  getRefundTimeData,
  getRefundProductData,
  getRefundCountryData,
  getRefundMoneyData
} from '@/server/data'

export default {
  name: 'sale-order',
  components: {
    reportCard,
    dataCard,
    reportTable
  },
  mixins: [setConfig],
  data() {
    return {
      currency: '',
      params: {
        startDate: moment()
          .subtract(29, 'days')
          .format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      },
      cardLoading: false,
      tableLoading: false,
      reportCardLoading: false,
      selectValue: '',
      shopList: [{ shopName: this.$t('system::common::select_all'), shopId: '' }],
      orderDate: [moment().subtract(29, 'days'), moment()], // 订单下单时间
      refundDate: [moment().subtract(29, 'days'), moment()], // 退款时间
      pickerOptions: {
        ...pickerOptions,
        disabledDate: time => {
          return time.getTime() >= Date.parse(new Date())
        }
      }, // 日期限制
      reportHeight: '400px', // 线型图高度
      refundMoneyData: {}, // 退款金额趋势图数据
      initiativeRefundData: {}, // 主动退款金额趋势图数据
      refuseCountData: {}, // 拒付金额趋势图数据
      SiteManagData: {}, // 各站点经营概况数据
      cardOptions: {}, // 四个数据
      shopTableConfig: {}, // 商品表格数据
      countryTableConfig: {}, // 国家表格数据
      selectedShop: '', // 选中的站点id
      refundTimeConfigs: [], // 退款时间占比
      refundMoney: 0, // 总退款金额
      refundReasonConfigs: [] // 退款原因占比
    }
  },
  methods: {
    reportJumpUrl,
    async orderDateChange(value) {
      this.params.start_date = moment(value[0]).format('YYYY-MM-DD')
      this.params.end_date = moment(value[1]).format('YYYY-MM-DD')
      this.getShopList()
      this.getRefundReasonConfigs()
      this.getShopTableConfig()
      this.getCountryTableConfig()
      await this.getCardOptions()
      this.getRefundTimeConfigs()
    },
    refundDateChange(value) {
      this.params.start_date = moment(value[0]).format('YYYY-MM-DD')
      this.params.end_date = moment(value[1]).format('YYYY-MM-DD')
      this.getRefundMoneyData()
    },
    refundSelectChange(value) {
      this.selectedShop = value
      this.getRefundMoneyData()
    },
    async handlerSelectChange(value) {
      this.selectedShop = value
      this.getShopList()
      this.getRefundReasonConfigs()
      this.getShopTableConfig()
      this.getCountryTableConfig()
      await this.getCardOptions()
      this.getRefundTimeConfigs()
    },
    async getShopList() {
      const { data } = await getShopList()
      if (data.code === this.$code && data.data) {
        this.shopList = [...this.shopList, ...data.data]
      }
    },
    async getRefundMoneyData() {
      this.reportCardLoading = true
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj['shop_id'] = this.selectedShop
      const { data } = await getRefundMoneyData(obj)
      if (data.code === this.$code) {
        this.refundMoneyData = this.setRefundMoneyData(data.data.datas)
        this.initiativeRefundData = this.setInitiativeRefundData(data.data.datas)
        this.refuseCountData = this.setRefuseCountData(data.data.datas)
        this.reportCardLoading = false
      }
    },
    async getCardOptions() {
      this.cardLoading = true
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj['shop_id'] = this.selectedShop
      const { data } = await getRefundCount(obj)
      if (data.code === this.$code) {
        this.refundMoney = data.data.datas[0] ? data.data.datas[0].refundAmount : 0
        this.cardOptions = this.setCountList(data.data.datas[0] || {})
        this.currency = data.data.datas.currency
        this.cardLoading = false
      }
    },
    async getShopTableConfig() {
      this.tableLoading = true
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj['shop_id'] = this.selectedShop
      const { data } = await getRefundProductData(obj)
      if (data.code === this.$code) {
        this.shopTableConfig = this.setShopTableConfig(data.data.datas)
        this.tableLoading = false
      }
    },
    async getCountryTableConfig() {
      this.tableLoading = true
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj['shop_id'] = this.selectedShop
      const { data } = await getRefundCountryData(obj)
      if (data.code === this.$code) {
        this.countryTableConfig = this.setCountryTableConfig(data.data.datas)
        this.tableLoading = false
      }
    },
    async getRefundReasonConfigs() {
      this.reportCardLoading = true
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj['shop_id'] = this.selectedShop
      const { data } = await getRefundReasonData(obj)
      if (data.code === this.$code) {
        this.refundReasonConfigs = this.setRefundReasonConfigs(data.data.datas)
        this.reportCardLoading = false
      }
    },
    async getRefundTimeConfigs() {
      this.reportCardLoading = true
      let obj = {
        ...this.params
      }
      if (this.selectedShop) obj['shop_id'] = this.selectedShop
      const { data } = await getRefundTimeData(obj)
      if (data.code === this.$code) {
        this.refundTimeConfigs = this.setRefundTimeConfigs(data.data.datas, this.refundMoney, this.currency)
        this.reportCardLoading = false
      }
    }
  },
  async mounted() {
    this.getShopList()
    this.getRefundReasonConfigs()
    this.getShopTableConfig()
    this.getCountryTableConfig()
    this.getRefundMoneyData()
    await this.getCardOptions()
    this.getRefundTimeConfigs()
  }
}
</script>

<style lang="scss" scoped>
.card-content {
  margin-top: 10px;
}
.report-card {
  height: 400px;
}
</style>
